import MsLabel from './src/index.vue'

export default MsLabel
